export const endpoint = {
  API_BASE_URL: process.env.REACT_APP_API_URL_NODE,

  LOGIN: "/api/v1/auth/login",
  REFRESH_TOKEN: "/api/v1/auth/refreshToken",
  API_KEY_REDIRECTION: "/api/v1/auth/apiKeyLogin",
  COMPLETE_REGISTRATION: "/api/v1/auth/completeTenantRegistration",
  GET_USERS: "/api/v1/user/getUsers",
  GET_TENANTS: "/api/v1/tenant/getTenants",
  GET_FORMDATA: "/api/v1/tenant/getStoreTypeAndCurrency",
  GET_PLANS: "/api/v1/plan/get",
  GET_PLAN_BILLINGCYCLES: "/api/v1/plan/getBillingCyclesWithPlans",
  CREATE_PLAN: "/api/v1/plan/createPlan",
  GET_PLANDATA: "/api/v1/plan/getData",
  GET_PLAN_BY_ID: "/api/v1/plan/getById",
  UPDATE_PLAN: "/api/v1/plan/updatePlan",
  CREATE_TENANT: "/api/v1/tenant/onboardTenant",
  VALIDATE_TENANT: "/api/v1/tenant/validateTenant",
  GET_FEATURES: "/api/v1/feature/getFeature",
  CREATE_FEATURE: "/api/v1/feature/createfeature",
  UPDATE_FEATURE: "/api/v1/feature/updatefeature",
  CREATE_FEATURE_CONFIG: "/api/v1/feature/CreateFeatureConfig",
  GET_FEATURETREE: "/api/v1/feature/getFeatureTree",
  GET_CATEGORY: "/api/v1/feature/getFeatureCategory",
  GET_MODULE_BY_ID: "/api/v1/module/getModuleById",
  GET_MODULES: "/api/v1/module/get",
  GET_APPLICATIONS: "/api/v1/application/get",
  GET_ROLES: "/api/v1/role/get",
  GET_ROLE_BY_ID: "/api/v1/role/getRoleById",
  UPDATE_ROLE: "/api/v1/role/updateRole",
  CREATE_ROLE: "/api/v1/role/createRole",
  GET_PERMISSIONS: "api/v1/application/getSystemPermission",
  GET_ANALYTICS: "/api/v1/tenant/getDashboardData",
  GET_STORE_TYPES: "/api/v1/tenant/getStoreTypes",
  CHANGE_PASSWORD: "/api/v1/auth/changePassword",
  GET_TENANT_BY_ID: "/api/v1/tenant/getTenantById",
  UPDATE_TENANT: "/api/v1/tenant/updateTenant",
  UPDATE_TENANT_STAGE: "/api/v1/tenant/updateStageInfo",
  ADD_NEW_STAGE_INFO: "/api/v1/tenant/addNewStageInfo",
  GET_BILLING_HISTORY: "/api/v1/billing/getBillingHistory",
  CREATE_USER: "/api/v1/user/createUser",
  UPDATE_USER: "/api/v1/user/updateUser",
  PURGE_TENANTS: "/api/v1/tenant/purgeUninstalledTenants",
  GET_USAGE: "/api/v1/tenant/getStoreUsage",
  GET_KNOWLEDGE_CENTER_DATA: "/api/v1/knowledgecentre/get",
  CREATE_KNOWLEDGE_CENTER: "/api/v1/knowledgecentre/create",
  UPDATE_KNOWLEDGE_CENTER: "/api/v1/knowledgecentre/update",
  GET_KNOWLEDGE_CENTER_BY_ID: "/api/v1knowledgecentre/getById",
  SEND_OTP: "/api/v1/auth/sendOtp",
  VERIFY_OTP: "/api/v1/auth/verifyOtp",
  GET_ENTITY_LIST_BY_TYPE: "/api/v1/knowledgecentre/getEntityListByType",
  GET_ONBOARD_OPTIONS: "/api/v1/tenant/getOnboardingOptions",
  CREATE_ONBOARD_TENANT:"/api/v1/tenant/onboardTenant",
  GET_SETTINGS: "/api/v1/tenant/getSettings",
  UPDATE_SETTINGS: "/api/v1/tenant/updateSettings",
  GET_CHECKLIST_OPTIONS: "/api/v1/tenant/getChecklist",
};
